import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./assets/css/main.css";
import "./assets/css/mobile.css";
import { BrowserRouter } from 'react-router-dom';

// Ignore non-fatal browser ResizeObserver loop warning in development overlay
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
      e.message.includes('ResizeObserver loop limit exceeded')) {
    e.stopImmediatePropagation();
  }
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </BrowserRouter>
);
